import React from 'react';
import { ArrowRightIcon, GlobeIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { CountdownTimer } from '../CountdownTimer';
import { ScarcityBar } from '../ScarcityBar';
const flow = ['What to review', 'What to assess', 'What to decide', 'What to follow up'];
export function FinalCta() {
  return <section className="w-full bg-navy px-4 py-14 sm:px-6 sm:py-20" aria-labelledby="final-title" data-id="element-186" data-mp="1smrpaleppekx">
      <div className="mx-auto max-w-3xl text-center" data-id="element-187" data-mp="1eniclvppt2lp">
        <p className="text-[12px] font-extrabold uppercase tracking-[0.14em] text-rose-light" data-id="element-188" data-mp="1ipn2cjd1lf32">
          Ready to stop starting from zero?
        </p>
        <h2 id="final-title" className="mt-3 font-display text-[30px] font-bold leading-[1.15] text-white sm:text-[44px]" data-id="element-189" data-mp="14roqbkm71uqq">
          Start using 5-MIN MENOPAUSE™ today
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-[15px] leading-relaxed text-white/75 sm:text-[17px]" data-id="element-190" data-mp="2z4y07dinji9i">
          Your next menopause patient doesn’t need you to remember hundreds of pages. You need a
          process — a 5-step clinical framework for structuring menopause consultations.
        </p>

        <div className="mt-7 flex flex-wrap items-center justify-center gap-1.5" data-id="element-191" data-mp="3tf62fuels94b">
          {flow.map((step, index) => <React.Fragment key={step} data-id="element-192" data-mp="6ztmrc9fuwn3" data-mpi={index}>
              {index > 0 ? <ArrowRightIcon className="h-3.5 w-3.5 shrink-0 text-white/35" aria-hidden="true" data-id="element-193" data-mp="70mvgiryjw7v" /> : null}
              <span className="rounded-lg bg-white/10 px-3 py-2 text-[11.5px] font-extrabold uppercase tracking-wide text-white" data-id="element-194" data-mp="3fhhnt4b4py7p">
                {step}
              </span>
            </React.Fragment>)}
        </div>

        <div className="mx-auto mt-9 max-w-xl" data-id="element-195" data-mp="3jgqge5ufnq1o">
          <CtaButton label="Yes, I want 5-MIN MENOPAUSE™" data-id="element-196" data-mp="3jfxbzbiy5cmp" />
          <p className="mt-3 text-[12.5px] font-medium text-white/65" data-id="element-197" data-mp="13paz2a2xfgxr">
            Only $27 · Instant access · Lifetime access · 7-day guarantee
          </p>
        </div>

        <p className="mt-4 flex items-start justify-center gap-1.5 text-[12.5px] font-medium text-white/65" data-id="element-198" data-mp="3sj96qar5o45g">
          <GlobeIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-teal" aria-hidden="true" data-id="element-199" data-mp="1c6f5i7envup" />
          Automatic currency conversion at checkout where supported.
        </p>

        <div className="mx-auto mt-9 max-w-xl" data-id="element-200" data-mp="5cgien3tc85v">
          <CountdownTimer tone="dark" data-id="element-201" data-mp="acb9aqnl8xqx" />
        </div>

        <div className="mx-auto mt-6 max-w-xl" data-id="element-202" data-mp="39shriskhljj5">
          <ScarcityBar tone="dark" data-id="element-203" data-mp="39tsskkmjsd6k" />
        </div>
      </div>
    </section>;
}